export default "__VITE_ASSET__Cr9d_6z5__"